const parseVersion = version => {
  const parts = (version || '').split('.');
  if (parts.length !== 4 || parts.some(part => !/^\d+$/.test(part))) {
    return null;
  }
  return parts.map(Number);
};

// The version the server writes next, which bumps the last part of the current one.
export const getNextPolicyVersion = currentVersion => {
  const parsed = parseVersion(currentVersion);
  if (!parsed) {
    return '1.0.0.0';
  }
  const [major, minor, build, revision] = parsed;
  return `${major}.${minor}.${build}.${revision + 1}`;
};
